// Supabase client configuration with iOS-optimized session storage
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getStorage } from '@/lib/storage/cookieStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Use cookie storage on mobile (iOS Safari ITP clears localStorage after 7 days)
    // Desktop continues using localStorage for better compatibility
    storage: getStorage(),
    // Custom storage key to avoid Safari ITP partitioning issues
    storageKey: 'dextoro-auth-token',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // PKCE flow for embedded wallet contexts
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-client-info': 'dextoro-launch',
    },
  },
});